export default __webpack_public_path__ + "static/edx-labs-logo-red-black-8dd40d6edcfc70faf6eb82640a3ecc4e.png";